import React, { useState, useEffect } from "react";
import Skeleton from '@material-ui/lab/Skeleton';
import Grid from '@material-ui/core/Grid';
import Card from "./Card";
import Divider from '@material-ui/core/Divider';
import { makeStyles, Typography } from "@material-ui/core";
import Button from '@material-ui/core/Button';

const useStyles = makeStyles({
    gridContainer: {
      paddingLeft: "100px",
      paddingRight: "100px",
      paddingTop : "20px"
    },
    button : {
        paddingLeft: "50px",
        paddingRight: "50px",
        color : '#379683',
        borderColor : '#c92828',
        borderRadius : 16,
        padding : "24px",
        width : '300px',
        fontSize : '20px',  
        // paddingLeft : "15px",
        // paddingRight : "15px",
        //marginBottom : "30px"
    },
    myProjectTitle : {
        paddingLeft : "100px",
        paddingBottom : "10px",
        color : '#c92828'
    },
    divider :{
        paddingBottom : "2px",
        marginLeft : "100px",
        width : "300px",
        background : '#379683'
    }
  });

  


function Repo(props) {

    // const [userData, setUserData] = useState({});
    // const [loading,setLoading] = useState(true);
    const classes = useStyles();

    // const generateLyaout = ()=>{
    //     return 
    //     })
    // };

    // generateCard(){
    //     if(props.userData.length >=6){

    //     }
    // }
    // useEffect(() => {
    //     getGitHubUserWithFetch();
    // }, []);

    // // $.getGithubFileByFilePath(
    // //     "parmaraakash7", 
    // //     "parmaraakash7", 
    // //     "README.md", 
    // //     function(contents) {
    // //     console.log(contents)
    // // });

    // const getGitHubUserWithFetch = async () => {
    //     const response = await fetch(gitHubRepoUrl,
    //         {
    //             headers: {
    //               authorization: `${token}`
    //             }
    //         }
    //     );
        
    //     const jsonData = await response.json();
    //     //console.log(`res = ${jsonData}`);
    //     setUserData(jsonData);
    //     setLoading(false);
    // };

    const goto = ()=>{
        window.open(props.userData[0].owner.html_url); 
    }


    // if(loading){
    //     return (
    //         <div>
    //             <Skeleton animation="wave" className={classes.myProjectTitleSkeleton} variant="rect" width={300} height={10}  />
    //             <Grid container spacing={4} className={classes.gridContainer} justify="center">
    //             <Grid item xs={12} sm={6} md={4} lg={4}>
    //             <Skeleton animation="wave" variant="rect" width={410} height={200} />
    //             </Grid>
    //             <Grid item xs={12} sm={6} md={4} lg={4}>
    //             <Skeleton animation="wave" variant="rect" width={400} height={200} />
    //             </Grid>
    //             <Grid item xs={12} sm={6} md={4} lg={4}>
    //             <Skeleton animation="wave" variant="rect" width={400} height={200} />
    //             </Grid>
    //             <Grid item xs={12} sm={6} md={4} lg={4}>
    //             <Skeleton animation="wave" variant="rect" width={400} height={200} />
    //             </Grid>
    //             <Grid item xs={12} sm={6} md={4} lg={4}>
    //             <Skeleton animation="wave" variant="rect" width={400} height={200} />
    //             </Grid>
    //             <Grid item xs={12} sm={6} md={4} lg={4}>
    //             <Skeleton animation="wave" variant="rect" width={400} height={200} />
    //             </Grid>
    //             </Grid>
    //         </div>
            
    //     )
    // }
    // else{
    //     return (
    //         <>
    //         <Typography variant="h3" className={classes.myProjectTitle}>
    //             My Projects
    //         </Typography>
    //         <Divider variant="inset" className={classes.divider} />
    //         <Grid container spacing={4} className={classes.gridContainer} justify="center">
    //             <Grid item xs={12} sm={6} md={4} lg={4}>
    //                 <Card 
    //                 repoName={props.userData[0].name} 
    //                 description={props.userData[0].description}
    //                 stars={props.userData[0].watchers_count}
    //                 language={props.userData[0].language}
    //                 html_url={props.userData[0].html_url}
    //                 languages_url={props.userData[0].languages_url}
    //                 />
    //             </Grid>
    //             <Grid item xs={12} sm={6} md={4} lg={4}>
    //             <Card 
    //                 repoName={props.userData[1].name} 
    //                 description={props.userData[1].description}
    //                 stars={props.userData[1].watchers_count}
    //                 language={props.userData[1].language}
    //                 html_url={props.userData[1].html_url}
    //                 />
    //             </Grid>
    //             <Grid item xs={12} sm={6} md={4} lg={4}>
    //             <Card 
    //                 repoName={props.userData[2].name} 
    //                 description={props.userData[2].description}
    //                 stars={props.userData[2].watchers_count}
    //                 language={props.userData[2].language}
    //                 html_url={props.userData[2].html_url}
    //                 />
    //             </Grid>
    //             <Grid item xs={12} sm={6} md={4} lg={4}>
    //             <Card 
    //                 repoName={props.userData[3].name} 
    //                 description={props.userData[3].description}
    //                 stars={props.userData[3].watchers_count}
    //                 language={props.userData[3].language}
    //                 html_url={props.userData[3].html_url}
    //                 />
    //             </Grid>
    //             <Grid item xs={12} sm={6} md={4} lg={4}>
    //             <Card 
    //                 repoName={props.userData[4].name} 
    //                 description={props.userData[4].description}
    //                 stars={props.userData[4].watchers_count}
    //                 language={props.userData[4].language}
    //                 html_url={props.userData[4].html_url}
    //                 />
    //             </Grid>
    //             <Grid item xs={12} sm={6} md={4} ls={4}>
    //             <Card 
    //                 repoName={props.userData[5].name} 
    //                 description={props.userData[5].description}
    //                 stars={props.userData[5].watchers_count}
    //                 language={props.userData[5].language}
    //                 html_url={props.userData[5].html_url}
    //                 />
    //             </Grid>
    //             <Grid item >
    //                 <Button 
    //                 variant="outlined" 
    //                 className={classes.button}
    //                 onClick={goto}
    //                 >
    //                     Show All
    //                 </Button>
    //             </Grid>
    //         </Grid>
    //         </>
    //     )
    // }
    const generateText = ()=>{
        if(props.originalUserDataLength > 6){
            return <Button 
            variant="outlined" 
            className={classes.button}
            onClick={goto}
            >
                Show All
            </Button>
        }
        else if(props.originalUserDataLength === 0){
            return <Typography style={{color : 'red'}}>
                No projects added
            </Typography>
        }
    
    }
    return (
        <>
        <Typography variant="h3" className={classes.myProjectTitle}>
            My Projects
        </Typography>
        <Divider className={classes.divider} />
        <Grid container spacing={4} className={classes.gridContainer} justify="center">
            {
                props.userData.map((repo,index)=>{
                    return (<Grid item xs={12} sm={6} md={4} lg={4}>
                    <Card 
                        repoName={props.userData[index].name} 
                        description={props.userData[index].description}
                        stars={props.userData[index].watchers_count}
                        language={props.userData[index].language}
                        html_url={props.userData[index].html_url}
                        languages_url={props.userData[index].languages_url}
                        />
                    </Grid>);
                })
            }  
        </Grid>
        <Grid container spacing={4} className={classes.gridContainer} justify="center">
            <Grid item >
                {
                    generateText()
                }
                    
                </Grid>
        </Grid>
        </>
    )
    
}

export default Repo
